import { render, staticRenderFns } from "./i-flip-clock.vue?vue&type=template&id=0862565d&"
import script from "./i-flip-clock.vue?vue&type=script&lang=js&"
export * from "./i-flip-clock.vue?vue&type=script&lang=js&"
import style0 from "./i-flip-clock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports